import { render } from "./EditBalanceForm.vue?vue&type=template&id=a90ffa9c&ts=true&lang=pug"
import script from "./EditBalanceForm.vue?vue&type=script&lang=ts"
export * from "./EditBalanceForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__